'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Dịch vụ hiện không có sẵn, vui lòng thử lại sau.',
    NEED_ACTIVE: 'Tài khoản {{account}} của bạn đang dùng trang web này lần đầu tiên. Vui lòng {{activeLink}} để hoàn tất việc kích hoạt và quay lại trang này để tiếp tục quá trình',
    GOTO_ACTIVE: 'Kich hoạt ngay',
    NOT_ACTIVED: 'Chưa kích hoạt tài khoản thành công, vui lòng {{activeLink}} để hoàn tất quá trình',
    COMPLETE_ACTIVE: 'Xác nhận kích hoạt',
    FORBID_ACTIVE: 'Tài khoản này không được hỗ trợ bởi AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Vui lòng đăng nhập bằng một tài khoản khác',
    ACTIVE_PAGE: 'Đến trang kích hoạt tài khoản'
};